<template>
  <footer>
    <slot></slot>
  </footer>
</template>

<script>
export default {
  name: 'xj-footer'
}
</script>